// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import { columns } from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, UserPlus} from 'react-feather'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import axios from "axios";
import Select from 'react-select'

// ** Utils
import { selectThemeColors } from '@utils'
import { countryOptions, signersList} from "../../../utility/helpers";
import CreateSigner from "./components/create-signer/create-signer";
import EditSigner from "./components/edit-signer/edit-signer";

const SignersList = () => {
    // ** States
    const [showCreateSignerModal, setShowCreateSignerModal] = useState(false);
    const [showEditSignerModal, setShowEditSignerModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [countryValue, setCountryValue] = useState(null)
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data);
    const [rowEdit, setRowEdit] = useState(null);

    const toggleCreateSignerModal = (show) => {
        setShowCreateSignerModal(show);
    }

    const toggleEditSignerModal = (show, row) => {
        setShowEditSignerModal(show);
        setRowEdit(row);
    }

    const getSigners = async () => {
        const response =  await axios.get(`${process.env.REACT_APP_API_URL}/signatories`)
        const signersList = response?.data.map((item) => {
            return {
                id: item.id, //
                fullName: item.fullName, //
                country: item.country,
                documentType: item.documentType,
                document: item.document,
                email: item.email,
                phone: item.phone, //
                company: item.name
            }
        });
        setData(signersList);
        // setData(signersList);
    }

    useEffect(() => {
        getSigners();
    }, []);


    // ** Function to handle filter
    const handleFilter = e => {
        const value = e.target.value
        let updatedData = []
        setSearchValue(value)

        if (value.length) {
            updatedData = data.filter(item => {
                const startsWith =
                    item.id.toString().toLowerCase().startsWith(value.toLowerCase()) ||
                    item.fullName.toLowerCase().startsWith(value.toLowerCase()) ||
                    // item.createDate.toLowerCase().startsWith(value.toLowerCase()) ||
                    // item.signerType.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.company.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.country.toLowerCase().startsWith(value.toLowerCase())

                const includes =
                    item.id.toString().toLowerCase().includes(value.toLowerCase()) ||
                    item.fullName.toLowerCase().includes(value.toLowerCase()) ||
                    // item.createDate.toLowerCase().includes(value.toLowerCase()) ||
                    // item.signerType.toLowerCase().includes(value.toLowerCase()) ||
                    item.company.toLowerCase().includes(value.toLowerCase()) ||
                    item.country.toLowerCase().includes(value.toLowerCase())

                if (startsWith) {
                    return startsWith
                } else if (!startsWith && includes) {
                    return includes
                } else return null
            })
            setFilteredData(updatedData)
            setSearchValue(value)
        }
    }

    const handleCountry = e => {
        if (e.value === '') {
            setCountryValue(null);
        } else {
            const updatedData = data.filter(item => {
                return item.country === e.label;
            });
            setCountryValue(e);
            setFilteredData(updatedData);
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected)
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    // ** Custom Pagination
    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous />}
            nextLabel={<Next />}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={searchValue.length || countryValue ? Math.ceil(filteredData.length / 20) : Math.ceil(data.length / 20) || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (
        <Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Firmantes</CardTitle>
                </CardHeader>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex justify-content-end mt-1' md='6' sm='12'>
                        <Button
                            onClick={() => {
                                setRowEdit(null);
                                toggleCreateSignerModal(true);
                            }}
                            color='primary'
                            className='btn-sm'>
                            <UserPlus size={16} />
                            <span className={'ms-1'}>Crear Firmante</span>
                        </Button>
                    </Col>
                </Row>
                < hr/>
                <Row className='mx-0'>
                    <Col className='d-flex align-items-center justify-content-start mt-1' md='6' sm='12'>
                        <Label className='me-1' for='search-input'>
                            Pais
                        </Label>

                        <Select
                            className='mb-50 react-select w-25'
                            classNamePrefix='select'
                            options={[
                                { value: '', label: 'Todos' },
                                ...countryOptions
                            ]}
                            theme={selectThemeColors}
                            value={countryValue}
                            onChange={handleCountry}
                        />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-end mt-1' md='6' sm='12'>
                        <Label className='me-1' for='search-input'>
                            Buscar
                        </Label>

                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </Col>
                </Row>
                    <div className='react-dataTable'>
                        <DataTable
                            noHeader
                            pagination
                            columns={columns(toggleEditSignerModal)}
                            paginationPerPage={20}
                            className='react-dataTable'
                            sortIcon={<ChevronDown size={10} />}
                            paginationComponent={CustomPagination}
                            paginationDefaultPage={currentPage + 1}
                            data={searchValue.length || countryValue ? filteredData : data}
                        />
                    </div>
            </Card>


            <CreateSigner isOpen={showCreateSignerModal} handleClose={toggleCreateSignerModal}/>
            <EditSigner isOpen={showEditSignerModal} handleClose={toggleEditSignerModal} item={rowEdit}/>

        </Fragment>
    )
}

export default SignersList
